import styled from 'styled-components';
import { MachineCard, MachineCardContainer, MachineCardImg, MachineValueText } from '../Investment/Investment.styled';

export const MinersOwnedContainer = styled.div`
    padding-inline: 15px;
`
export const MinersCardContainer = styled(MachineCardContainer)``
export const MinersCard = styled(MachineCard)``
export const MinersCardImg = styled(MachineCardImg)``
export const MinersValueText = styled(MachineValueText)``;